export default __webpack_public_path__ + "static/media/GMaduroChurchillOpen.80520ba5.jpg";